export default {
  CUSTOMER: 'customerMaster',
  INVOICE: 'invoiceInquiry',
  PO: 'purchaseOrderEntry',
  POREQ: 'specialPurchaseRequisitions',
  REPORT: 'documentViewer',
  SO: 'salesOrder',
  ST: 'stockTransferEntry'
}
